import React, { useState } from 'react';
import classNames from 'classnames';
import Icon, { ICONS, COLORS } from './icon';

export interface SelectGroupOption {
	iconSize?: number;
	label: string;
	shortLabel?: string;
	value: any;
	selected?: boolean;
	description?: string;
	className?: string;
	icon?: string;
}

export interface SelectGroupProps {
	options: SelectGroupOption[],
	onChange: (event: any) => any;
	label: string;
	selected: SelectGroupOption;
	placeholder: string;
	invalid?: boolean;
	labelStyle?: any;
}

export default function SelectGroup(props: SelectGroupProps) {
	const {
		options,
		onChange,
		label,
		selected,
		invalid,
		labelStyle,
	} = props;

	const [open, setOpen] = useState(false);
	const [activeClass, setActiveClass] = useState('closed');

	function animationFinished() {
		if (open && activeClass === 'closed') {
			setOpen(false);
		}
	}

	function close() {
		setActiveClass('closed');
	}

	function openSelect() {
		setOpen(true);
		setTimeout(() => setActiveClass('open'), 16);
	}

	return (
		<div className={classNames('select-group', { open, invalid: invalid || false })}>
			<label className="select-label" onClick={openSelect} style={labelStyle || {}}>{label}</label>
			<div className="select-background" onClick={close}></div>
			<span onClick={openSelect} className={classNames('main-label', { open: activeClass !== 'closed' })}>{selected.label || ''}
				<span className="caret">
					<svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1.27094 0.228824C0.9901 -0.0650263 0.523473 -0.0762935 0.228695 0.203658C-0.0660828 0.48361 -0.0773854 0.948767 0.20345 1.24262C0.20345 1.24262 4.60439 5.77719 4.61717 5.78955C4.92128 6.07934 5.40348 6.06851 5.69419 5.76535L10.0814 1.24266C10.3627 0.949277 10.3522 0.484101 10.0579 0.203658C9.7636 -0.0767845 9.29696 -0.0662955 9.01563 0.227086L5.34256 3.94922C5.23294 4.06031 5.05365 4.06033 4.944 3.94927L1.27094 0.228824Z" fill="#878793" />
					</svg>
				</span>
			</span>
			<div onClick={openSelect} className={classNames('select-body', activeClass)} onTransitionEnd={animationFinished}>
				{options.map((opt) => (
					<div
						key={opt.value}
						onClick={(e) => {
							e.stopPropagation();
							onChange(opt.value);
							close();
						}}
						className={classNames('select-option', { selected: opt.value === selected.value })}>
						<label className={opt.className}>{opt.label}</label>
						<span className="checkmark"><Icon size={15} color={COLORS.WHITE} name={ICONS.CHECK} /></span>
					</div>
				))}
			</div>
		</div>
	);
}
